import Vue from 'vue'

import outsideClickDirective from '~/utils/directives/outsideClick'

Vue.directive('outside-click', outsideClickDirective)
